import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Store, Select } from '@ngxs/store';

import { BcStateContext, BcStateListContext } from '@bayclubs/state';
import { BcCalendarEvent, BcCalendarResource, BcCalendarSettings } from '@bayclubs/calendar';

import { ClassesCalendarSelectors } from './classes-calendar.selectors';
import * as actions from './classes-calendar.actions';
import { GetGroupClassesCalendarQuery } from '@bayclubs/group-classes-employee-api';

@Injectable({ providedIn: 'root' })
export class ClassesCalendarFacade {
    @Select(ClassesCalendarSelectors.calendarSettings) calendarSettings$: Observable<BcStateContext<BcCalendarSettings>>;
    @Select(ClassesCalendarSelectors.calendarEvents) calendarEvents$: Observable<BcStateListContext<BcCalendarEvent>>;
    @Select(ClassesCalendarSelectors.calendarResources) calendarResources$: Observable<BcStateListContext<BcCalendarResource>>;
    @Select(ClassesCalendarSelectors.selectedClubId) selectedClubId$: Observable<string>;

    constructor(private store: Store) {}

    selectedClubIdSnapshot = () => this.store.selectSnapshot(ClassesCalendarSelectors.selectedClubId);
    eventIdsSnapshot = () => this.store.selectSnapshot(ClassesCalendarSelectors.eventIds);

    loadClassesCalendar = (query: GetGroupClassesCalendarQuery) =>
        this.store.dispatch(new actions.LoadClassesCalendarAction(query));
    loadClassesCalendarContext = () => this.store.dispatch(new actions.LoadClassesCalendarContextAction());
    initFiltersForm = () => this.store.dispatch(new actions.InitClassesCalendarFiltersFormAction());
    setSelectedClubId = (clubId: string) => this.store.dispatch(new actions.SetSelectedClubId(clubId));
}
